import styled, { ThemeProps } from 'styled-components';
import fonts from '../../../../helpers/fonts';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';
import { Theme } from '../../../../theme';
import { themeSpecificColors } from '../../../../theme/RSA/colors';

export const StyledTestimonialCardDoubleMarks = styled.div<{
  themeColor: ({ theme }: ThemeProps<Theme>) => string;
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${({ themeColor }) => themeColor};
  border-radius: 0;
  padding: ${spacing(3)};
  width: 100%;
  position: relative;
  margin-bottom: ${spacing(4)};

  ${fonts.paragraph};
  & {
    color: white;
  }

  ${mediaQuery.tabletPortrait`
    padding: ${spacing(4)};
    font-size: 20px;
    line-height: 32px;
  `}
`;
export const TestimonialIconTop = styled.div`
  padding: 0 0 ${spacing(0.5)};
  display: block;
`;
export const TestimonialIconBottom = styled.div`
  padding: ${spacing(0.5)} 0 0;
  display: block;
  margin-right: 0;
  margin-left: auto;
`;
export const TestimonialAuthorInfo = styled.div`
  ${fonts.paragraphSmall};
  padding: ${spacing(1)} 0 ${spacing(1)};
`;
export const JobTitleSpan = styled.span`
  color: ${themeSpecificColors.core04_40};
`;
